import { h, render, Component } from 'preact';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import { FmSearchInput } from './fm-search-input';
import L from 'leaflet';

export class AddressSearchTool extends Component {
    constructor() {
        super();
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.provider = new OpenStreetMapProvider();
        this.state = {
            searchResults: [],
            isSearchTooltipOpen: false
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    onShowPointOnMap(item) {
        this.setState({ searchResults: [], isSearchTooltipOpen: false });
        this.props.openAddressSearchTool(false);
        if (item.y !== null && item.x !== null) {
            let circle = L.circle([item.y, item.x], {
                color: 'red',
                fillOpacity: 0.5,
                radius: 10
            }).addTo(this.props.map);

            this.props.map.fitBounds(circle.getBounds());
            setTimeout(() => {
                this.props.map.mapRemoveLayer(circle);
            }, 10000);
        }
    }

    onSearchAddress(value) {
        this.provider
            .search({ query: value })
            .then((results) => {
                this.setState({ searchResults: results, isSearchTooltipOpen: true });
            })
            .catch(() => {
                let results = [{
                    bounds: null,
                    label: messages['api_request_error'],
                    raw: null,
                    x: null,
                    y: null,
                }];
                this.setState({ searchResults: results, isSearchTooltipOpen: true });
            });
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ searchResults: [], isSearchTooltipOpen: false });
            this.props.openAddressSearchTool(false);
        }
    }

    render(props, state) {
        return (
            <div ref={this.setWrapperRef} class="map-toolbar-address-search">
                <div class="map-toolbar-address-search__input-wrapper">
                    <FmSearchInput search={this.onSearchAddress.bind(this)} />
                </div>
                {
                    this.state.isSearchTooltipOpen &&
                    <div class="map-toolbar-address-search__tooltip">
                        {
                            this.state.searchResults.length > 0
                                ? this.state.searchResults.map(item =>
                                    <div key={item.label} class="map-toolbar-address-search__tip" onClick={() => this.onShowPointOnMap(item)}>
                                        {item.label}
                                    </div>
                                )
                                : <div class="map-toolbar-address-search__tip">{messages['nothing_was_found']}</div>
                        }
                    </div>
                }
            </div>
        );
    }
}
